import { ColumnsType } from 'antd/es/table'
import { SortOrder } from 'antd/es/table/interface'
import { Sorter } from '../../../../../components/Sorter/Sorter'
import { LeadByIndicator } from '../../../../../components/LeadByIndicator'
import { Status } from '../../../../../components/Status'
import { Link } from '../../../../../components/Link'
import { routes } from '../../../../../router'
import {
  CATEGORY_STATUS_NAME,
  CATEGORY_STATUS_TO_CLASSNAME
} from '../../../../Categories/constants'
import { AddContractCategoryTableData } from './types'

export const columns: ColumnsType<AddContractCategoryTableData> = [
  {
    dataIndex: 'name',
    key: 'name',
    className: 'vertical-align-middle',
    title: ({ sortOrder, sortColumn }) => (
      <Sorter<AddContractCategoryTableData>
        dataIndex="name"
        sortColumn={sortColumn}
        sortOrder={sortOrder as SortOrder}
      >
        Contract category
      </Sorter>
    ),
    render: (_, { name, uuid }) => (
      <Link
        to={`${routes.contracts}${routes.contractCategories}/${uuid}`}
        target="_blank"
      >
        {name}
      </Link>
    ),
    sorter: true,
    showSorterTooltip: false
  },
  {
    dataIndex: 'led_by',
    key: 'led_by',
    width: '64px',
    title: 'Led by',
    className: 'vertical-align-middle',
    render: (_, { led_by }) =>
      led_by ? <LeadByIndicator value={led_by} /> : '-',
    sorter: false,
    showSorterTooltip: false
  },
  {
    dataIndex: 'status',
    key: 'status',
    title: 'Category status',
    className: 'vertical-align-middle',
    render: (_, { status }) =>
      status ? (
        <Status.Default className={CATEGORY_STATUS_TO_CLASSNAME[status]}>
          {CATEGORY_STATUS_NAME[status]}
        </Status.Default>
      ) : (
        '-'
      ),
    sorter: false,
    showSorterTooltip: false
  }
]
